import { monteurApi } from '../common/monteur-api';
export var globalSearchApi = monteurApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getGlobalSearchAll: builder.query({
            query: function (req) {
                return {
                    url: "GlobalSearch/search-all?searchText=".concat(encodeURIComponent(req.searchText), "&Module=").concat(req.module, "&EnablePagination=").concat(req.enablePagination, "&UserId=").concat(req.userId),
                    method: 'GET'
                };
            }
        }),
        getGlobalSearchFiles: builder.query({
            query: function (req) {
                return {
                    url: "GlobalSearch/search-files?searchText=".concat(encodeURIComponent(req.searchText), "&EnablePagination=").concat(req.enablePagination, "&UserId=").concat(req.userId),
                    method: 'GET'
                };
            }
        }),
        getGlobalSearchFileResults: builder.query({
            query: function (req) {
                return {
                    url: "GlobalSearch/search-file?SearchText=".concat(encodeURIComponent(req)),
                    method: 'GET'
                };
            },
            keepUnusedDataFor: 0
        })
    }); }
});
export var useLazyGetGlobalSearchAllQuery = globalSearchApi.useLazyGetGlobalSearchAllQuery, useLazyGetGlobalSearchFilesQuery = globalSearchApi.useLazyGetGlobalSearchFilesQuery, useLazyGetGlobalSearchFileResultsQuery = globalSearchApi.useLazyGetGlobalSearchFileResultsQuery;
